<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Nome: </span>
      <span> {{orgaoJulgador.nome}}</span>
    </div>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{orgaoJulgador.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Órgão Justica:</label>
      <div class="p-col-12 p-md-10">
        <a [routerLink]="['/orgaoJustica/visualizar/', orgaoJulgador?.orgaoJustica?.id]">
          {{orgaoJulgador?.orgaoJustica?.nome}}
        </a>
     </div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Jurisdição:</label>
      <div class="p-col-12 p-md-10">
        <a [routerLink]="['/jurisdicao/visualizar/', orgaoJulgador?.jurisdicao?.id]">
          {{orgaoJulgador?.jurisdicao?.nome}}
        </a>
      </div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome:</label>
      <span class="p-col-12 p-md-10">{{orgaoJulgador.nome}} </span>
    </div>
    <div class="p-field p-grid"  *ngIf="instanciaItens">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Situação:</label>
      <div class="p-col-12 p-md-10">
        <span  *ngIf="orgaoJulgador.situacao === 'ATIVO'" class="badge badge-success m-l-8">Ativo</span>
        <span *ngIf="orgaoJulgador.situacao === 'INATIVO'" class="badge badge-danger m-l-8">Inativo</span>
      </div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Instância:</label>
      <div class="p-col-12 p-md-10">
<!--        {{getInstanciaItens(orgaoJulgador.instancia)}}-->
        {{orgaoJulgador.instancia | dominio:'getFonteDadosInstanciaItens'}}
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-col-12">
      <button pButton appBotaoVoltar class="p-button-primary  p-lg-12" label="Voltar"></button>
    </div>
  </ng-template>
</p-card>

